import {gql} from "@apollo/client";

/**
 * 历史包裹下载（数据源 order_listing_history 索引）。
 *
 * 与 generateParcelDownloadReport 签名一致（filters + timezone → fileName），仅数据源不同：
 * 该接口走归档历史索引，普通包裹下载走实时 order_listing / MySQL。历史页专用。
 */
export const GENERATE_ORDER_HISTORY_DOWNLOAD_REPORT = gql`
    mutation GenerateOrderHistoryDownloadReport($filters: OrderFiltersTypeInput, $timezone: String) {
        generateOrderHistoryDownloadReport(filters: $filters, timezone: $timezone)
    }
`;

export interface GenerateOrderHistoryDownloadReportResponse {
    generateOrderHistoryDownloadReport: string;
}

export interface GenerateOrderHistoryDownloadReportVariables {
    filters?: any;
    timezone?: string;
}
